import Vue from 'vue';
import 'es6-promise/auto';
import { createApp } from './main';
import VueLazyload from 'vue-lazyload';
import Toast from '@/components/toast';
import Popup from '@tuniu/dpl-vui/lib/popup';
import Dialog from '@tuniu/dpl-vui/lib/dialog';
import datetimepicker from "@tuniu/dpl-vui/lib/datetime-picker";

__webpack_public_path__ = window.resource_link ? (window.resource_link('') + 'libs/item/') : '/';

Vue.use(VueLazyload);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(datetimepicker);

Vue.prototype.getAppLink = function (url) {
    if (typeof window !== 'undefined' && window.app_url) {
        let urlPrefixer = window.app_url('').replace(/^http(s)?:\/\/.*?\//, '').replace(/\/$/, '');
        return urlPrefixer ? ('/' + urlPrefixer + url) : url;
    } else {
        return url;
    }
};

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
    beforeRouteUpdate (to, from, next) {
        const { asyncData } = this.$options
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            }).then(next).catch(next)
        } else {
            next()
        }
    }
})

const { app, router, store } = createApp()

document.addEventListener('DOMContentLoaded', function(event) {
    // prime the store with server-initialized state.
    // the state is determined during SSR and inlined in the page markup.
    if (window.__INITIAL_STATE__) {
        store.replaceState(window.__INITIAL_STATE__)
    }

    // wait until router has resolved all async before hooks
    // and async components...
    router.onReady(() => {
        // Add router hook for handling asyncData.
        // Doing it after initial route is resolved so that we don't double-fetch
        // the data that we already have. Using router.beforeResolve() so that all
        // async components are resolved.
        router.beforeResolve((to, from, next) => {
            const matched = router.getMatchedComponents(to)
            const prevMatched = router.getMatchedComponents(from)
            let diffed = false
            const activated = matched.filter((c, i) => {
                return diffed || (diffed = (prevMatched[i] !== c))
            })
            const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _)
            if (!asyncDataHooks.length) {
                return next()
            }

            Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
                .then(() => {
                    next()
                })
                .catch(next)
        })

        // actually mount to DOM
        app.$mount('#J_app')
    })
});



// WEBPACK FOOTER //
// libs/entry-client.js